import { Component, Input, EventEmitter, Output, OnInit, ViewChild } from '@angular/core';
import { Customer, AutocompleteService, EntityAutocompleteComponent } from 'orv-ui-base-lib';

@Component({
  selector: 'app-custom-multi-select',
  templateUrl: './custom-multi-select.component.html',
  styleUrls: ['./custom-multi-select.component.scss']
})
export class CustomMultiSelectComponent implements OnInit {

  @Input() label: string = 'labels.select-customer';
  @Input() field: string;
  @Input() customService: AutocompleteService;

  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('autocomplete') autocomplete: EntityAutocompleteComponent;

  newData: any[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  onSelect(item: Customer) {
    if (item && item.id) {
      this.newData.push(item);
      this.select.emit(this.newData);
      this.reset();
    }
  }

  clear(item: Customer) {
    const index = this.newData.map(c => c.id).indexOf(item.id);
    this.newData.splice(index, 1);
  }

  clearAll() {
    this.newData = [];
    this.select.emit(this.newData);
    this.reset();
  }

  private reset() {
    window.requestAnimationFrame(() => {
      this.autocomplete.element.nativeElement.value = '';
    });
  }

}
